import { Artigo } from './../../classes/artigo';
import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';
import { AuxService } from '../aux.service';

@Component({
  selector: 'app-article-summary',
  templateUrl: './article-summary.component.html',
  styleUrls: ['./article-summary.component.css'],
  standalone: false,
})
export class ArticleSummaryComponent {
  constructor(
    private router: Router,
    private aux: AuxService,
  ) {}

  @Input() articleSummary: Artigo;

  redirectArticle() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([
        '/category/' +
          this.aux.slugify(this.articleSummary.categoria) +
          '/article/' +
          this.articleSummary.resumo,
      ]);
    });
  }

  redirectTag(tag) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/tag'], { queryParams: { s: encodeURI(tag) } });
    });
  }
}
